module.exports = __webpack_public_path__ + "img/picto_datos.5c4e753a.svg";